export default __webpack_public_path__ + "static/media/special-link-featured.d00fd3e0.svg";